/**
 * NovaSuperhero — "Superhero" persona tile. Cape deployed. Justice is a gentle 6px hover.
 * Timing: 1.1s cape flutter · 2.2s fly. Geometry generated from the canonical Character
 * Bible catalog (nova.js) — regenerate rather than hand-editing paths.
 * Animations come from nova.css via the `expr-superhero` wrapper class
 * (applied by <NovaExpression id="superhero" />).
 */
import * as React from "react";

export function NovaSuperhero({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 460 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Nova the superhero">
      {/* speed streaks */}
      <g stroke="#1C1A17" strokeWidth="3.5" strokeLinecap="round">
        <line className="hero-streak"    x1="380" y1="120" x2="440" y2="120"/>
        <line className="hero-streak s2" x1="396" y1="200" x2="450" y2="200"/>
        <line className="hero-streak s3" x1="386" y1="300" x2="444" y2="300"/>
      </g>
      <g className="hero-fly-wrap">
        <g transform="translate(50 0)">
          {/* cape behind body, anchored at left shoulder */}
          <g className="hero-cape">
            <path d="M 78 318 Q 18 392 8 448 Q 90 436 148 462 Q 100 386 112 322 Z" fill="#D4541F" stroke="#1C1A17" strokeWidth="2.5" strokeLinejoin="round"/>
          </g>
        </g>
        
        
      <defs>
        <linearGradient id="bodyG-n7" x1="0.15" y1="0" x2="0.85" y2="1">
          <stop offset="0" stopColor="#709c9e"/>
          <stop offset="0.45" stopColor="#2D6E70"/>
          <stop offset="1" stopColor="#1e494a"/>
        </linearGradient>
        <linearGradient id="chestG-n7" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#174143"/>
          <stop offset="1" stopColor="#3a6b6d"/>
        </linearGradient>
        <radialGradient id="scrG-n7" cx="0.5" cy="0.45" r="0.8">
          <stop offset="0" stopColor="#0E1626"/>
          <stop offset="0.72" stopColor="#0E1626"/>
          <stop offset="1" stopColor="#060A12"/>
        </radialGradient>
        <pattern id="pxg-n7" width="9" height="9" patternUnits="userSpaceOnUse">
          <path d="M 9 0 L 0 0 0 9" fill="none" stroke="#060A12" strokeWidth="1.6" opacity="0.65"/>
        </pattern>
        <filter id="eglow-n7" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="6"/>
        </filter>
      </defs>
        <g transform="translate(50 0)">
        
        
        <g className="nova-body" style={{ transformOrigin: "180.00px 472.00px" }} transform="rotate(-10 180 347)">
          {/* Antenna stem (drawn first so head covers its base) */}
          <line x1="180" y1="122" x2="180" y2="42.60000000000001" stroke="#1C1A17" strokeWidth="2.2" strokeLinecap="round"/>
          {/* Orbital ring (behind ball, ivory) */}
          <ellipse cx="180" cy="42.60000000000001" rx="15" ry="5.3999999999999995" stroke="#F4EFE6" strokeWidth="1.6" fill="none" transform="rotate(-12 180 42.60000000000001)"/>
          {/* Antenna ball */}
          <circle className="antenna-ball" cx="180" cy="42.60000000000001" r="7" fill="#D4541F"/>
          <ellipse cx="177.9" cy="40.150000000000006" rx="2.94" ry="2.1" fill="#FFFFFF" opacity="0.55"/>
          {/* Front half of orbital ring (over ball) so it appears to encircle */}
          <path d="M 165.3 43.10000000000001 A 15 5.3999999999999995 -12 0 0 194.7 40.400000000000006"
                stroke="#F4EFE6" strokeWidth="1.6" fill="none" opacity="0.95"/>
          
    
          {/* HEAD outer (glossy) */}
          <rect x="60" y="110" width="240" height="170" rx="36" fill="url(#bodyG-n7)"/>
          {/* Bezel inset (darker ring) */}
          <rect x="82" y="132" width="196" height="126" rx="28" fill="#1F5759"/>
          {/* Face screen: recessed navy display */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#scrG-n7)"/>
    
          {/* Cheeks (on teal head, flanking screen) */}
          
    
          {/* Eyes: glow pass + sharp pass */}
          <g filter="url(#eglow-n7)" opacity="0.75">
          
          <path d="M 140.62 161.92 Q 142.10 156.10 144.95 161.39 L 179.15 224.89 Q 181.99 230.17 176.04 230.90 L 127.27 236.89 Q 121.32 237.62 122.80 231.81 Z" fill="#A8C8E8" opacity="0.25"/>
          <path d="M 215.05 161.39 Q 217.90 156.10 219.38 161.92 L 237.20 231.81 Q 238.68 237.62 232.73 236.89 L 183.96 230.90 Q 178.01 230.17 180.85 224.89 Z" fill="#A8C8E8" opacity="0.25"/>
        
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 141.58 169.70 Q 143.06 163.88 145.90 169.17 L 172.13 217.85 Q 174.97 223.14 169.02 223.87 L 132.39 228.37 Q 126.43 229.10 127.91 223.28 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 214.10 169.17 Q 216.94 163.88 218.42 169.70 L 232.09 223.28 Q 233.57 229.10 227.61 228.37 L 190.98 223.87 Q 185.03 223.14 187.87 217.85 Z" fill="#A8C8E8" opacity="1"/></g>
        </g>
          
          
          <path d="M 140.62 161.92 Q 142.10 156.10 144.95 161.39 L 179.15 224.89 Q 181.99 230.17 176.04 230.90 L 127.27 236.89 Q 121.32 237.62 122.80 231.81 Z" fill="#A8C8E8" opacity="0.25"/>
          <path d="M 215.05 161.39 Q 217.90 156.10 219.38 161.92 L 237.20 231.81 Q 238.68 237.62 232.73 236.89 L 183.96 230.90 Q 178.01 230.17 180.85 224.89 Z" fill="#A8C8E8" opacity="0.25"/>
        
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 141.58 169.70 Q 143.06 163.88 145.90 169.17 L 172.13 217.85 Q 174.97 223.14 169.02 223.87 L 132.39 228.37 Q 126.43 229.10 127.91 223.28 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 214.10 169.17 Q 216.94 163.88 218.42 169.70 L 232.09 223.28 Q 233.57 229.10 227.61 228.37 L 190.98 223.87 Q 185.03 223.14 187.87 217.85 Z" fill="#A8C8E8" opacity="1"/></g>
        
    
          {/* Single quiet tear (Sad) — on face screen, below right eye */}
          
    
          {/* Pixel grid over the display (LED look) */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#pxg-n7)"/>
          {/* Screen glare */}
          <ellipse cx="146.88" cy="148" rx="55.199999999999996" ry="9" fill="#8FB4E8" opacity="0.13"/>
          {/* Head specular */}
          <ellipse cx="112" cy="126" rx="36" ry="9" fill="#FFFFFF" opacity="0.35" transform="rotate(-10 112 126)"/>
    
          {/* BODY outer (glossy) */}
          <rect x="50" y="302" width="260" height="170" rx="36" fill="url(#bodyG-n7)"/>
          {/* Chest storage: interior + items behind a hinged door */}
          <rect x="72" y="324" width="216" height="126" rx="26" fill="#0B1220"/>
          <g className="chest-items" style={{ opacity: "0" }}>
            <path d="M 141.12 358 l 6.2 12.7 13.9 2 -10 9.8 2.4 13.9 -12.5 -6.6 -12.5 6.6 2.4 -13.9 -10 -9.8 13.9 -2 Z" fill="#D4A02C"/>
            <g transform="translate(190.8 368)">
              <rect x="0" y="0" width="44" height="30" rx="5" fill="#1C1A17"/>
              <circle cx="22" cy="15" r="9" fill="#3A3733" stroke="#F4EFE6" strokeWidth="1.4"/>
              <rect x="31" y="3" width="8" height="5" rx="1.5" fill="#3A3733"/>
            </g>
          </g>
          {/* Chest door (hinged at left edge) */}
          <g className="chest-door" style={{ transformOrigin: "74px 387.0px" }}>
            <rect x="72" y="324" width="216" height="126" rx="26" fill="url(#chestG-n7)"/>
            <line x1="79" y1="336" x2="79" y2="438" stroke="#0B1220" strokeWidth="2.4" opacity="0.55"/>
            <circle cx="272" cy="387.0" r="5" fill="#6d9293"/>
          </g>
          {/* Body specular */}
          <ellipse cx="98" cy="316" rx="30" ry="7" fill="#FFFFFF" opacity="0.25" transform="rotate(-8 98 316)"/>
    
          {/* Arms (drawn over body) */}
          
          <g className="float-arm float-arm-l">
            <rect x="8" y="326" width="30" height="96" rx="15" fill="url(#bodyG-n7)"/>
            <ellipse cx="18" cy="339" rx="7" ry="4" fill="#FFFFFF" opacity="0.32"/>
          </g>
          <g className="float-arm float-arm-r">
            <rect x="322" y="326" width="30" height="96" rx="15" fill="url(#bodyG-n7)"/>
            <ellipse cx="332" cy="339" rx="7" ry="4" fill="#FFFFFF" opacity="0.32"/>
          </g>
        
        </g>
        </g>
      
        <g transform="translate(50 0)">
          {/* chest emblem: star on the chest panel */}
          <path d="M 180 358 l 7.6 15.5 17 2.5 -12.3 12 2.9 17 -15.2 -8 -15.2 8 2.9 -17 -12.3 -12 17 -2.5 Z" fill="#D4A02C" stroke="#1C1A17" strokeWidth="2"/>
        </g>
      </g>
    </svg>
  );
}
